import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {
    // const [open, setOpen] = React.useState(false);

    // const handleClose = () => {
    //     setOpen(false);
    //     props.close(false)

    // };

    const handleCloseOnCancel = () => {
        // handleClose()
        props.close()
    }

    const handleCloseOnAgree = () => {
        // handleClose()
        props.close()
        props.agree()
    }


    return (
        <div>
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Warning⚠️"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.children}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseOnCancel} color="primary">
                        {props.canceltxt}
          </Button>
                    <Button onClick={handleCloseOnAgree} color="secondary" autoFocus>
                        {props.proceedtxt}
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
